import * as z from "zod";

// Response of GET {REACT_APP_DATA_RS_ROOT}/api/v1/rigfrac/values.
// `values` maps each attribute key (operator, county, basin, subBasin,
// locationType, type, stateProvince, country, rigTrajectory) to a sorted,
// deduplicated string array.
// `countyStates` maps each countyUnique to its stateProvince (EVA-338);
// optional because older services omit it.
export const RigFracValuesResponseSchema = z.object({
  values: z.record(z.string(), z.array(z.string())),
  countyStates: z.record(z.string(), z.string()).optional(),
  dataAsOf: z.string().optional(),
  recencyCutoff: z.string().optional()
});

export type RigFracValuesResponse = z.infer<typeof RigFracValuesResponseSchema>;

export function safeParseRigFracValues(data: unknown) {
  return RigFracValuesResponseSchema.safeParse(data);
}
